import { Component, OnInit, inject } from '@angular/core';
import { Router, Event as NavigationEvent, NavigationEnd, RouterLink } from '@angular/router';
import { LoginService } from '../../service/login.service';
import { UserService } from '../../service/user.service';
import { UserDetail } from 'src/app/models/user.detail';
import { QmLicense } from 'src/app/models/qm.license.models/qm.license';
import { UserMenuService } from 'src/app/service/user.menu.service';
import { SharedFunctionService } from 'src/app/service/shared.function.service';
import { DataLoader } from 'src/app/service/data.loader';
import { UserMenuGroup } from 'src/app/models/admin-user-menu/user-menu-control.model';

import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatDivider } from '@angular/material/list';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'nav-menu',
  templateUrl: './navmenu.component.html',
  styleUrls: ['./navmenu.component.scss'],
  imports: [RouterLink, MatMenuTrigger, MatMenu, MatMenuItem, MatDivider, MatButton],
})
export class NavMenuComponent implements OnInit {
  router = inject(Router);
  loginService = inject(LoginService);
  userService = inject(UserService);
  userMenuService = inject(UserMenuService);
  sharedFunction = inject(SharedFunctionService);
  dataLoader = inject(DataLoader);

  userDetail: UserDetail;
  currentLicense: QmLicense;
  isDevMode: boolean = false;
  adminUserMenuGroup: UserMenuGroup[];

  constructor() {
    this.userDetail = new UserDetail();
    this.userDetail.FirstName = '';
    this.userDetail.UserLogo = '';

    this.currentLicense = new QmLicense();
    this.currentLicense.Name = 'FREE';

    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationEnd) {
        // reload user info when page has been changed
        this.loadUserData();
      }
    });
  }

  ngOnInit() {
    this.loadUserData();

    this.isDevMode = this.sharedFunction.isQaSite();
  }

  loadUserData() {
    if (this.loginService.isLogin()) {
      this.loadUserInfo();
      this.adminUserMenuGroup = this.userMenuService.getLoginUserMenuGroups();
    }
  }

  logout() {
    this.loginService.logout();
  }

  loadUserInfo() {
    // check if user logined and never load user detail
    if (this.loginService.isLogin() && this.userDetail.FirstName === '') {
      this.userService.getUserDetail(userDetail => {
        this.userDetail = userDetail;
        this.loadUserLicenseInfo();
      });
    } else {
      this.loadUserLicenseInfo();
    }
  }

  loadUserLicenseInfo() {
    // reload user license
    this.currentLicense = this.loginService.getUserLicense();
  }
}
